import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { SetField } from '../components/Table/fields/SetField';
import { Guide } from '../types/entities/Guide';
import { languageSkills } from './languageSkills';
import { DateField } from '../components/Table/fields/DateField';
import { SelectField } from '../components/Table/fields/SelectField';
import { enumItems } from './enumItems';
import { BooleanField } from '../components/Table/fields/BooleanField';

export const guide: SchemaWithClient<Guide> = {
  name: 'Guide',
  pluralName: 'Guide',
  columns: {
    name: {
      name: 'Name',
      required: true,
      fieldRenderer: TextField,
      fieldType: 'text',
    },
    phone: {
      name: 'Phone',
      fieldRenderer: TextField,
      fieldType: 'text',
    },
    email: {
      name: 'Email',
      fieldRenderer: TextField,
      fieldType: 'text',
    },
    tax_number: {
      name: 'TAX Number',
      fieldRenderer: TextField,
      fieldType: 'text',
    },
    social_security_number: {
      name: 'Social Security Number',
      fieldRenderer: TextField,
      fieldType: 'text',
    },
    birthplace: {
      name: 'Birthplace',
      fieldRenderer: TextField,
      fieldType: 'text',
    },
    birthdate: {
      name: 'Birthdate',
      fieldRenderer: DateField,
      fieldType: 'date',
    },
    language_skills: {
      name: 'Language Skills',
      fieldRenderer: SetField.tableAdapter(languageSkills),
      url: languageSkills.client.getAllPath,
      tempSchema: languageSkills,
      multiSwitchboard: true,
    },
    mothers_name: {
      name: 'Mothers Name',
      fieldRenderer: TextField,
      fieldType: 'text',
    },
    nationality: {
      name: 'Nationality',
      fieldRenderer: SelectField.tableAdapter(enumItems.country),
      url: enumItems.country.client.getAllPath,
      tempSchema: enumItems.country,
      fieldType: 'text',
    },
    permanent_address: {
      name: 'Permanent Address',
      fieldRenderer: TextField,
      fieldType: 'text',
    },
    temporary_address: {
      name: 'Temporary Address',
      fieldRenderer: TextField,
      fieldType: 'text',
    },
    bank_account_number: {
      name: 'Bank Account Number',
      fieldRenderer: TextField,
      fieldType: 'text',
    },
    realization: {
      name: 'Realization',
      fieldRenderer: TextField,
      fieldType: 'text',
    },
    tour_guide_exam: {
      name: 'Tour Guide Exam',
      fieldRenderer: BooleanField,
      fieldType: 'boolean',
    },
    images: {
      name: 'Images',
      fieldRenderer: TextField,
      fieldType: 'text',
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      fieldType: 'number',
      readOnly: true,
    },
  },
  client: new Client('/guides'),
};
